import { OperationType } from 'src/app/widgets/filters/miscellaneous/operation-type.enum';
import { PopupControl } from 'src/app/models/popup-control.model';
import { Router, UrlTree } from '@angular/router';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { UtilsService } from 'src/app/services/utils.service';
import { SettingsService } from 'src/app/pages/settings/settings.service';

import { ServiceLocator } from "src/app/tools/service-locator.tool";
import { ForecastEsoMergedMapping, ForecastEsoObjectsMapping, SchemaToPageMapping } from '../models/forecast-eso-merged-mapping.model';
import { QueryFilterParameter } from '../../filters/models/query-filter-parameter.model';

export class JumpToOperator {

	public popupControl: PopupControl = new PopupControl(
		{
			title: 'FC/ESO Mapping',

			width: 450,
			height: 200
		}
	);

	public mergedMapping: ForecastEsoMergedMapping;

	public popupMappedCodes: string[] = [];
	public popupMappedCodesFc: string[] = [];
	public selectedPopupMappedCode: string;

	public selectedSchema: SchemaToPageMapping;

	// private _selectedPageName = "";

	private _pageType: 'eso' | 'fc';
	public get pageType(): 'eso' | 'fc' {
		return this._pageType;
	}
	public set pageType(value: 'eso' | 'fc') {
		this._pageType = value;

		
		if (this._selectedCode && this._pageType) {
			this.initializeMappings();
		}
	}

	private _selectedCode: string;
	public get selectedCode(): string {
		return this._selectedCode;
	}
	public set selectedCode(value: string) {
		this._selectedCode = value;

		
		if (this._selectedCode && this._pageType) {
			this.initializeMappings();
		}
	}

	public onSchemaItemClicked(evt: any) {
		const clickedSchema: SchemaToPageMapping = (<SchemaToPageMapping>evt.itemData);

		this.selectedSchema = clickedSchema;

		console.error(this.selectedSchema, this.mergedMapping, this.selectedCode);

		if (this.mergedMapping) {
			if (this.selectedSchema.pageSchema === this.pageType || (this.selectedSchema.pageSchema === 'st' && this.pageType === 'eso')) {
				this._navigates.jumpToNavigateTO(
					this.selectedSchema.pageRelativeUrl,
					this.selectedSchema.pageSchema,
					this.selectedCode
				);
			} else if (this.selectedSchema.pageSchema === 'eso' || this.selectedSchema.pageSchema === 'st') {
				// We are on FC page but cliked on ESO.

					let availableMappings: ForecastEsoObjectsMapping[] = this.mergedMapping.mappings.filter(
						(mapping: ForecastEsoObjectsMapping) => mapping.forecastObjectClientId === UtilsService.getURLHelperDeconding(this.selectedCode)
					);

				if (availableMappings.length === 1) {
					this._navigates.jumpToNavigateTO(
						this.selectedSchema.pageRelativeUrl,
						this.selectedSchema.pageSchema,
						availableMappings[0].productId
					);
				} else {
					this.popupControl.show();
				}
			} else if (this.selectedSchema.pageSchema === 'fc') {
				// We are on ESO page but clicked on FC.

				let availableMappings: ForecastEsoObjectsMapping[] = this.mergedMapping.mappings.filter(
					(mapping: ForecastEsoObjectsMapping) => mapping.productId === UtilsService.getURLHelperDeconding(this.selectedCode)
				);

				if (availableMappings.length === 1) {
					this._navigates.jumpToNavigateTO(
						this.selectedSchema.pageRelativeUrl,
						this.selectedSchema.pageSchema,
						availableMappings[0].forecastObjectClientId
					);
				} else {
					this.popupControl.show();
				}
			}
		}
		else {
			this.popupControl.visible = true;
		}
	}

	public navigateToSelectedSchemaWithPopupMappedCode() {
		if (this.selectedSchema) {
			this._navigates.jumpToNavigateTO(
				this.selectedSchema.pageRelativeUrl,
				this.selectedSchema.pageSchema,
				this.selectedPopupMappedCode
			);
		}
	}

	public initializeMappings() {
		const $this = this;

		this._settingsService.getFcEsoPageMappings(
			[
				new QueryFilterParameter(
					this.pageType === 'eso' ? 'eo.ProductId' : 'fo.ForecastObjectClientId',
					this.selectedCode,
					OperationType.Equals
				)
			],
			{
				name: `initializeMappings -> getFcEsoPageMappings[productCode: ${this.selectedCode}]`,
				showLoadingIndicator: false,
				responseLoggingEnabled: false
			}
		).subscribe(
			{
				next: (response) => {
					const urlTree: UrlTree = this._router.parseUrl(this._router.url);

					urlTree.queryParams = {}; // "Delete" the parameters that might have been there.
					urlTree.fragment = null;

					$this.mergedMapping = response;

					// Remove current page url from schemas.
					if ($this.mergedMapping && $this.mergedMapping.schemas) {
						$this.mergedMapping.schemas = $this.mergedMapping.schemas.filter((item: any) => item.pageRelativeUrl !== urlTree.toString());
					}

					$this.popupMappedCodes = $this.mergedMapping.mappings.map(
						(mapping: ForecastEsoObjectsMapping) => mapping.productId
					);
					$this.popupMappedCodesFc = $this.mergedMapping.mappings.map(
						(mapping: ForecastEsoObjectsMapping) => mapping.forecastObjectClientId
					);
				}
			}
		);
	}

	//#region <Services>

	private _settingsService: SettingsService = ServiceLocator.injector.get(SettingsService);
	private _router: Router = ServiceLocator.injector.get(Router);
	private _navigates: NavigateAssociates = ServiceLocator.injector.get(NavigateAssociates);

	//#endregion </Services>

	constructor() { }
}
